/**
 * Created by Kristy on 2/6/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDClinicNamesController', MDClinicNamesController);

    MDClinicNamesController.$inject = ['KendoGrid', '$http', '$filter', 'KendoFilter', 'ClinicName'];

    function MDClinicNamesController (KendoGrid, $http, $filter, KendoFilter, ClinicName) {
        var vm = this;

        var onSaveSuccess = function () {
            KendoGrid.refresh(vm.mainGridOptions);
        };

        vm.pageHeading = $filter('translate')('masterData.clinicNames.title');

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) {
                            o.data.filter = { filters: [] };
                        }
                        $http.get('/api/clinic-names/search',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        ClinicName.update(data, onSaveSuccess);
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        ClinicName.update(data, onSaveSuccess);
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}},
                            updatedAt: { editable: false }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
